import { createApp } from 'vue';
import Rw2ToAvifConverter from '../Components/Rw2ToAvifConverter.vue';

const root = document.getElementById('rw2-to-avif-converter');
if (root) {
  createApp(Rw2ToAvifConverter).mount('#rw2-to-avif-converter');
}
